import { render, staticRenderFns } from "./ProductBulkEditDetails.vue?vue&type=template&id=4d94dfc4"
import script from "./ProductBulkEditDetails.vue?vue&type=script&lang=js"
export * from "./ProductBulkEditDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports